export function toFrames(seconds, fps) {
    return Math.ceil(seconds * fps);
}
export function toSeconds(frames, fps) {
    return frames / fps;
}
// prevents any JS weirdness with floating point numbers
function normalizeFrame(frameWithMaybeFraction) {
    return Math.ceil(frameWithMaybeFraction);
}
export function getDurationInFrames({ startFrame, endFrame, }) {
    startFrame = normalizeFrame(startFrame);
    endFrame = normalizeFrame(endFrame);
    if (endFrame < startFrame) {
        throw Error(`End frame (${endFrame}) cannot be less than start frame (${startFrame})`);
    }
    if (startFrame < 0 || endFrame < 0) {
        throw Error(`Frames cannot be negative. Got start frame: ${startFrame}, end frame: ${endFrame}`);
    }
    // Why do we add 1? If a scene is only one frame long, it's start and end
    // frames are the same so you have to add one to get the number of frames in
    // the scene. For example, if a scene starts on frame 100 and ends on frame
    // 101, then it's two frames long.
    return endFrame - startFrame + 1;
}
/**
 * This gives you the endFrame if you start at startFrame and play for duration
 * frames. Note that duration is not the total duration of the scene, but the
 * duration from startFrame.
 */
export function getEndFrame({ startFrame, duration }) {
    startFrame = normalizeFrame(startFrame);
    duration = normalizeFrame(duration);
    if (duration <= 0) {
        throw Error(`Duration must be greater than zero. Got ${duration}`);
    }
    if (startFrame < 0) {
        throw Error(`Values cannot be negative. Got start frame: ${startFrame}, duration: ${duration}`);
    }
    // Why do we subtract 1? Frames start at zero. For example, if a scene starts
    // at frame 100 and is only one frame long, its end frame is also 100.
    return startFrame + duration - 1;
}
/**
 * Will probably use this to get the start frame of the next scene, but can be
 * used on anything that has a start frame and a duration, therefore the
 * function name uses the term "item".
 */
export function getStartFrameOfNextItem({ currentItemStartFrame, currentItemDuration, }) {
    currentItemStartFrame = normalizeFrame(currentItemStartFrame);
    currentItemDuration = normalizeFrame(currentItemDuration);
    if (currentItemDuration <= 0) {
        throw Error(`Duration must be greater than zero. Got ${currentItemDuration}`);
    }
    if (currentItemStartFrame < 0) {
        throw Error(`Start frame cannot be negative. Got ${currentItemStartFrame}`);
    }
    // we don't need to add 1 here because adding the duration gets us to the
    // first frame of the next item
    return currentItemStartFrame + currentItemDuration;
}
